module.exports = __webpack_public_path__ + "static/media/logic.afb1172e.svg";